export const environment = {
  type:'dev',
  production: true,
  tenant:"isepmpocb2c.onmicrosoft.com",
  clientId:'a86ebaa2-4675-4fa4-89ba-280378a4831c',
  redirectURI:'http://localhost:4200/app-login',
  signInPolicy: "B2C_1_sign",
  signUpSignInPolicy : "B2C_1_sign",
  forgotpass:"B2C_1_pass",
  B2CTodoAccessTokenKey:"b2c.access.token",
  testSignUp:"https://investorstest.infosys.com/sign-up",
  devSignup:"http://localhost:4200/sign-up",
  // validateUser:'https://10.177.41.135/registeruser/v1/ValidateNewUser',
  // registerUser:'https://10.177.41.135/registeruser/v1/AddUser',
  // profileServiceGet:'https://10.177.41.135/profile/v1/fetchProfileByToken',
  // profileServicePost:'https://10.177.41.135/profile/v1/updateProfileByToken',
  // countryList:'https://10.177.41.135/profile/v1/fetchCountryList',
  // taxFormsHeader:'https://10.177.41.135/form/v1/getTaxFormHeader',
  // uploadTaxForm:'https://10.177.41.135/form/v1/getApplicableFormTypes',
  // onlineFormServiceGet:'https://10.177.41.135/form/v1/loadFormForProfile/',
  // onlineFormServicePost:'https://10.177.41.135/form/v1/uploadForm',
  telemetryBaseUrl:'https://itgateway.infosys.com/platform/investorptl/telemetry/',
  telemetryEndPoint: 'v1/telemetry',
  // uploadDocumentForm: 'https://10.177.41.135/form/v1/uploadToAzure',
  // getUserAcceptance:'https://10.177.41.135/dp/v1/getUserAcceptance/1.0',
  // saveDpConsent:'https://10.177.41.135/dp/v1/saveDpConsent',
  telemetryFlg:true,
  // getAllDocByType:'http://10.177.41.135/form/v1/getAllDocByTypeForProfile',
  // downloadFile:'http://10.177.41.135/form/v1/downloadFileFromAzure',
  // deleteFile:'http://10.177.41.135/form/v1/form/v1/deleteDocument',
  isCycleActive: '1',
  blShowCaptcha: false,
  blBotFlag:'enabled',
  botName:'infymemobile',
  baseURL:'https://infymebotft.ad.infosys.com/api/request',
  spellCheckInitializeCheckURL:'https://infymebotft.ad.infosys.com/api/spellchecker/check/infymemobile',
  spellCheckInitializeURL:'https://infymebotft.ad.infosys.com/api/spellchecker/initialize/infymemobile',
  correctSentenceURL:'https://infymebotft.ad.infosys.com/api/spellchecker/sentence/infymemobile',
  bestWordsURL:'https://infymebotft.ad.infosys.com/api/spellchecker/bestwords/infymemobile/',
  sessionTime:900,
  maskingFlag:true,
  
  validateUser:'https://itgateway.infosys.com/platform/investorptl/registeruser/v1/ValidateNewUser',
  registerUser:'https://itgateway.infosys.com/platform/investorptl/registeruser/v1/AddUser',
  //profileServiceGet:'https://itgateway.infosys.com/platform/investorptl/profile/v1/fetchProfileByToken',
  profileServicePost:'https://itgateway.infosys.com/platform/investorptl/profile/v1/updateProfileByToken',
  countryList:'https://itgateway.infosys.com/platform/investorptl/profile/v1/fetchCountryList',
 // taxFormsHeader:'https://itgateway.infosys.com/platform/investorptl/form/v1/getTaxFormHeader',
  //uploadTaxForm:'https://itgateway.infosys.com/platform/investorptl/form/v1/getApplicableFormTypes',
  //onlineFormServiceGet:'https://itgateway.infosys.com/platform/investorptl/form/v1/loadFormForProfile/',
  onlineFormServicePost:'https://itgateway.infosys.com/platform/investorptl/form/v1/uploadForm',
//   telemetryBaseUrl:'https://itgateway.infosys.com/investorptl/telemetry/',
//   telemetryEndPoint: 'v1/telemetry',
  uploadDocumentForm: 'https://itgateway.infosys.com/platform/investorptl/form/v1/uploadToAzure',
  getUserAcceptance:'https://itgateway.infosys.com/platform/investorptl/dp/v1/getUserAcceptance/1.0',
  saveDpConsent:'https://itgateway.infosys.com/platform/investorptl/dp/v1/saveDpConsent',
//   telemetryFlg:true,
  //getAllDocByType:'http://itgateway.infosys.com/platform/investorptl/form/v1/getAllDocByTypeForProfile',
  downloadFile:'https://itgateway.infosys.com/platform/investorptl/form/v1/downloadFileFromAzure',
  deleteFile:'https://itgateway.infosys.com/platform/investorptl/form/v1/deleteDocument',
  signUpSignIn: 'B2C_1_sign',
  resetPassword: 'B2C_1_resetpassword',
  b2cScopes: 'https://b2cinvestortst.onmicrosoft.com/b2ctestapi/user_impersonation',
  redirectUriInv: 'https://investorstest.infosys.com',
  postLogoutRedirectUri: 'https://investorstest.infosys.com',
  cacheLocationFlag: true,
  prodBaseUrl: 'https://itgateway.infosys.com/platform/',
   downloadFileTDS:'http://itgateway.infosys.com/investorptl/docdownload/v1/download',
  portalOpen: "Dear Shareholder, Kindly note that the portal shall be available for the shareholder to submit the tax forms or various tax documents till  June 06, 2025. No tax forms or tax documents will be considered after June 06, 2025, 8:00 PM. We request you to kindly take note of the same accordingly. Thank you and wishing you a safe stay.",
  portalClose: "Dear Shareholder, the window for submission of tax forms/declarations pertaining to taxation(TDS) of dividend for Interim Dividend of FY 2024-25 is closed. The submitted documents will be processed as per the provisions of the tax law.  Please reach out dividend.tax@infosys.com for any queries. Thank you and wishing you a safe stay.",
   recordDate:"2024-05-31",
   resident206ABNonCompliant: "You have been identified as specified person under section 206AB of Income tax act 1961, hence the taxes will be deducted at higher applicable rates.",
   nonResident206ABNonCompliant: "You have been identified as specified person under section 206AB of Income tax act 1961. Kindly submit 206AB declaration to avoid deduction of taxes at applicable higher rates.",   
  taxFormsHeader:'https://itgateway.infosys.com/gatewayinvestorptl/investorptl/form/v1/getTaxFormHeader', 
    uploadTaxForm:'https://itgateway.infosys.com/gatewayinvestorptl/investorptl/form/v1/getApplicableFormTypes', 
    getAllDocByType:'https://itgateway.infosys.com/gatewayinvestorptl/investorptl/form/v1/getAllDocByTypeForProfile', 
    onlineFormServiceGet:'https://itgateway.infosys.com/gatewayinvestorptl/investorptl/form/v1/loadFormForProfile/',  
    profileServiceGet:'https://itgateway.infosys.com/gatewayinvestorptl/investorptl/profile/v1/fetchProfileByToken',
    keycloak: {
      url:'https://infysso.infosysapps.com/auth/',
      realm: 'Investorportal', // Realm name
      clientId: 'SW52ZXN0b3Jwb3J0YWw=',  // Client ID
    },
    logOutUrl:'https://infysso.infosysapps.com/auth/realms/Investorportal/protocol/openid-connect/logout?redirect_uri=https://investorstest.infosys.com/',
   reCAPTCHASiteKey:'6LfvekYqAAAAAIT25nTWeYlVHXOIciHr0I8dD9mb',
   //logOutUrl:'https://infysso-poc.infosysapps.com/auth/realms/Investor/protocol/openid-connect/logout?redirect_uri=http://localhost:4200/',

  };
